function remove_item(key) {
  event.preventDefault();
  var data = {
    quantity: 0,
    id: key
  }

  fetch(theme.routes.cartChange, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
  }).then(e => e.json()).then(function(e) {
  if (422 === e.status || "bad_request" === e.status)
  ;
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  .bind(this));
}

// QUICK SHOP FEATURE FROM PEN BY AJ
const customModal = document.getElementById('custom_modal');
const customModalContent = customModal.querySelector('.custom-modal-content');
const MODAL_TYPES = ['custom-modal--bottom-center', 'custom-modal--center-center'];

function onCustomModalEscapeKey(element) {
  if (element.key === 'Escape') {
    hideCustomModal();
  }
}

function showCustomModal(html, options = {}) {
  const { type = 'bottom-center' } = options;
  MODAL_TYPES.forEach(cls => customModal.classList.remove(cls));
  customModal.classList.add(`custom-modal--${type}`);

  customModalContent.innerHTML = html;
  customModal.classList.remove('hidden');
  customModal.classList.add('modal-visible');

  const closeBtn = customModal.querySelector('.close-modal');
  if (closeBtn) {
    closeBtn.addEventListener('click', hideCustomModal);
  }
  const backdrop = customModal.querySelector('.custom-modal-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', hideCustomModal);
  }  
  document.addEventListener('keydown', onCustomModalEscapeKey);
}

function hideCustomModal() {
  customModal.classList.remove('modal-visible');
  customModal.classList.add('hidden');
  customModalContent.innerHTML = '';
  document.removeEventListener('keydown', onCustomModalEscapeKey);
}

function handleQuickShopClick(button) {
  const handle = button.dataset.productHandle;
  if (!handle) return;

  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      const colorOption = product.options.find(o => ["color", "colour"].includes(o.name.toLowerCase()));
      const colorIndex = colorOption ? product.options.findIndex(o => ["color", "colour"].includes(o.name.toLowerCase())) + 1 : null;

      const sizeOption = product.options.find(o => ["size", "size (int)"].includes(o.name.toLowerCase()));
      const sizeIndex = sizeOption ? product.options.findIndex(o => ["size", "size (int)"].includes(o.name.toLowerCase())) + 1 : null;

      let sizesHTML = "";
      if (sizeOption) {
        sizesHTML = `
          <p><strong>Available Sizes:</strong></p>
          <ul class="variant-list size-list">
            ${sizeOption.values.map(size => {
              const hasStock = product.variants.some(v => {
                return (!colorIndex || v[`option${colorIndex}`]) && 
                       v[`option${sizeIndex}`] === size && v.available;
              });
              return `
                <li>
                  <span 
                    class="variant-option ${hasStock ? '' : 'unavailable'}" 
                    data-option-type="size" 
                    data-option-value="${size}">
                    ${size}
                  </span>
                </li>
              `;
            }).join('')}
          </ul>
        `;
      }

      let colorsHTML = "";
      if (colorOption) {
        colorsHTML = `
          <p><strong>Available Colors:</strong></p>
          <ul class="variant-list color-list">
            ${colorOption.values.map(color => {
              const hasStock = product.variants.some(v => {
                return (!sizeIndex || v[`option${sizeIndex}`]) && 
                       v[`option${colorIndex}`] === color && v.available;
              });
              return `
                <li>
                  <span 
                    class="variant-option ${hasStock ? '' : 'unavailable'}" 
                    data-option-type="color" 
                    data-option-value="${color}">
                    ${color}
                  </span>
                </li>
              `;
            }).join('')}
          </ul>
        `;
      }

      if (!sizeOption && !colorOption) {
        showCustomModal('<p>No size or color options found for this product.</p>', { type: 'bottom-center' });
        return;
      }

      const modalContentHTML = `
        <div class="custom-quick-shop-html">
          <h2 class="product-title">${product.title}</h2>
          ${colorsHTML}
          ${sizesHTML}
          <button class="quick-add-to-cart-btn btn btn--full add-to-cart" disabled>Add to Cart</button>
        </div>
      `;

      showCustomModal(modalContentHTML, { type: 'bottom-center' });

      const modal = document.querySelector('.custom-quick-shop-html');
      const addToCartBtn = modal.querySelector('.quick-add-to-cart-btn');

      let selectedOptions = { size: null, color: null };

      function updateSizeAvailability(selectedColor) {
        if (!sizeIndex) return;

        modal.querySelectorAll('.variant-option[data-option-type="size"]').forEach(sizeEl => {
          const sizeValue = sizeEl.dataset.optionValue;

          const hasStock = product.variants.some(v =>
            v.available &&
            v[`option${sizeIndex}`] === sizeValue &&
            (!colorIndex || v[`option${colorIndex}`] === selectedColor)
          );

          sizeEl.classList.toggle('unavailable', !hasStock);

          if (!hasStock && sizeEl.classList.contains('active')) {
            sizeEl.classList.remove('active');
            selectedOptions.size = null;
          }
        });

        addToCartBtn.disabled = true;
        addToCartBtn.removeAttribute('data-variant-id');
      }

      function findMatchingVariant() {
        return product.variants.find(variant => {
          const matchSize = sizeIndex ? variant[`option${sizeIndex}`] === selectedOptions.size : true;
          const matchColor = colorIndex ? variant[`option${colorIndex}`] === selectedOptions.color : true;
          return matchSize && matchColor;
        });
      }

      modal.querySelectorAll('.variant-option').forEach(option => {
        option.addEventListener('click', () => {
          if (option.classList.contains('unavailable')) return;

          const optionType = option.dataset.optionType;
          const optionValue = option.dataset.optionValue;

          modal
            .querySelectorAll(`.variant-option[data-option-type="${optionType}"]`)
            .forEach(el => el.classList.remove('active'));

          option.classList.add('active');
          selectedOptions[optionType] = optionValue;

          if (optionType === 'color') {
            selectedOptions.size = null;
            modal
              .querySelectorAll('.variant-option[data-option-type="size"]')
              .forEach(el => el.classList.remove('active'));
            updateSizeAvailability(optionValue);
            addToCartBtn.disabled = true;
            addToCartBtn.removeAttribute('data-variant-id');
            return;
          }

          const matchedVariant = findMatchingVariant();
          if (matchedVariant && matchedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.dataset.variantId = matchedVariant.id;
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.removeAttribute('data-variant-id');
          }
        });
      });

      addToCartBtn.addEventListener('click', () => {
        const variantId = addToCartBtn.dataset.variantId;
        if (!variantId) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(res => res.json())
          .then(data => {
            // console.log('Added to cart:', data);
            addToCartBtn.disabled = true;
            var cartDrawer = new theme.CartDrawer();
            hideCustomModal();
            cartDrawer.open();
          })
          .catch(err => console.error("Add to cart error:", err));
      });
    })
    .catch(err => console.error("Fetch error:", err));
}

function bindQuickShop(button) {
  function handler(e) {
    e.preventDefault();
    e.stopPropagation();
    handleQuickShopClick(button);
  }

  // prevent double firing on mobile
  let touched = false;

  button.addEventListener('touchend', (e) => {
    touched = true;
    handler(e);
  });

  button.addEventListener('click', (e) => {
    if (touched) {
      touched = false;
      return; // prevent duplicate after touch
    }
    handler(e);
  });
}

function initQuickShopButtons(scope = document) {
  const buttons = scope.querySelectorAll('.quick-shop-btn:not([data-initialized])');

  buttons.forEach(button => {
    button.setAttribute('data-initialized', 'true');
    bindQuickShop(button);
  });
}

// INITIALIZE FUNCTIONS
function initThemeFeatures(scope = document) {
  if (scope === document) {
    initQuickShopButtons();
  }
  initProductGridSwipers(scope);
}

document.addEventListener('DOMContentLoaded', () => {
  // initPageLoader();
  initThemeFeatures();
});

document.addEventListener('shopify:section:load', (event) => {
  initThemeFeatures(event.target);
});


document.addEventListener("DOMContentLoaded", function(){

  const buttons = document.querySelectorAll(".view-toggle-btn");
  const productGrid = document.querySelector(".product-grid-container.collection-products");

  buttons.forEach(btn => {
    btn.addEventListener("click", function(){

      buttons.forEach(b => b.classList.remove("active"));
      this.classList.add("active");

      const view = this.dataset.view;

      productGrid.classList.remove("grid-1","grid-4");
      productGrid.classList.add(view);

      localStorage.setItem("collectionView", view);
    });
  });

  const saved = localStorage.getItem("collectionView");

  if(saved){
    productGrid.classList.remove("grid-1","grid-4");
    productGrid.classList.add(saved);

    buttons.forEach(btn=>{
      if(btn.dataset.view === saved){
        btn.classList.add("active");
      }else{
        btn.classList.remove("active");
      }
    });
  }

});

